<div class="createPrModal-container">
  <h3 cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    {{ 'CREATION_OF_NEW_PR' | translate }}
  </h3>

  <form class="createPrModal-form" [formGroup]="form">
    <div class="createPrModal-fieldForm">
      <mat-label class="createPrModal-fieldFormLabel">
        <div
          [ngClass]="[
            form.controls['name'].hasError('required')
              ? 'form-error'
              : 'form-valid'
          ]"></div>
        <span>{{ 'PR NAME' | translate }}</span>
      </mat-label>
      <mat-form-field>
        <input
          matInput
          formControlName="name"
          placeholder="{{ 'ENTER_NAME' | translate }}" />
        <mat-error>{{ 'FIELD_IS_REQUIRED' | translate }}</mat-error>
      </mat-form-field>
    </div>

    <div class="createPrModal-fieldForm">
      <mat-label class="createPrModal-fieldFormLabel">
        <div
          [ngClass]="[
            form.controls['currency'].hasError('required')
              ? 'form-error'
              : 'form-valid'
          ]"></div>
        <span>{{ 'PR_CURRENCY' | translate }}</span>
      </mat-label>
      <mat-form-field>
        <mat-select
          formControlName="currency"
          placeholder="{{ 'SELECT_CURRENCY' | translate }}">
          @for (currency of currencies; track currency.id) {
            <mat-option [value]="currency">{{ currency.name }}</mat-option>
          }
        </mat-select>
        <mat-error>{{ 'SELECTION_IS_REQUIRED' | translate }}</mat-error>
      </mat-form-field>
    </div>

    <div class="createPrModal-fieldType">
      <mat-label class="createPrModal-fieldTypeLabel">
        <div
          [ngClass]="{
            'form-error': form.controls['processTemplateId'].invalid,
            'form-valid': form.controls['processTemplateId'].valid
          }"></div>
        <h3 class="createPrModal-fieldTypeLabelText">
          {{ 'SELECT_THE_TYPE_OF_PR' | translate }}
        </h3>
      </mat-label>

      <div class="createPrModal-templateGroupsWrapper">
        <div class="createPrModal-templateGroups">
          @for (
            processTemplateGroup of processTemplateGroups;
            track processTemplateGroup.id
          ) {
            <div
              class="createPrModal-item"
              [ngClass]="{
                'createPrModal-item--selected':
                  form.controls['procedureTypeId'].value ===
                  processTemplateGroup.id
              }"
              (click)="selectProcessTemplateGroup(processTemplateGroup)">
              {{ processTemplateGroup.name }}
            </div>
          }
          @if (selectedProcessTemplateGroup) {
            <div class="active_arrow"></div>
          }
        </div>

        @if (
          form.controls['procedureTypeId'].hasError('required') &&
          form.get('procedureTypeId')?.touched
        ) {
          <mat-error class="createPrModal-customError"
            >{{ 'SELECTION_IS_REQUIRED' | translate }}
          </mat-error>
        }
      </div>

      @if (filteredProcessTemplates.length) {
        <div class="createPrModal-templatesWrapper">
          <div class="createPrModal-templates">
            @for (template of filteredProcessTemplates; track template.id) {
              <div
                class="createPrModal-item"
                [matTooltip]="template.description"
                [ngClass]="{
                  'createPrModal-item--selected':
                    form.controls['processTemplateId'].value === template.id
                }"
                (click)="selectProcessTemplate(template)">
                {{ template.name }}
              </div>
            }
          </div>
          @if (
            form.controls['processTemplateId'].hasError('required') &&
            form.get('processTemplateId')?.touched
          ) {
            <mat-error class="createPrModal-customError"
              >{{ 'SELECTION_IS_REQUIRED' | translate }}
            </mat-error>
          }
        </div>
      }
    </div>
  </form>

  <div class="createPrModal-footer">
    <button mat-stroked-button class="btn-secondary" (click)="onClose()">
      {{ 'CANCEL' | translate }}
    </button>
    <button
      mat-flat-button
      class="btn-primary"
      [disabled]="isCreateDisabled"
      (click)="onCreate()">
      {{ 'CREATE' | translate }}
    </button>
  </div>
</div>
